// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import AppContent from "../appContent/AppContent";

// const DefaultLayout = () => {
//   const nav = useNavigate();
//   const token = localStorage.getItem("token");
//   const checkToken = () => {
//     if (token === null) {
//       nav("/landing");
//     }
//   };

//   useEffect(() => {
//     checkToken();
//   });

//   return (
//     <div>
//       <AppContent />
//     </div>
//   );
// };

// export default DefaultLayout;

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppContent from "../appContent/AppContent";

const DefaultLayout = () => {
  const nav = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      nav("/landing");
    }
  }, [nav]);

  return (
    <div>
      <AppContent />
    </div>
  );
};

export default DefaultLayout;
